export const OTHER_OPTION = 'Other';
export const NOT_USED_WEBSITE_OPTIONS = "Didn't use a website";
export const ALREADY_SOLD_REASON = 'I already sold my car';

export const SURVEY_TEXTS = {
  MODAL_TITLE: 'Your listing is deactivated',
  OTHER_PLACEHOLDER: 'Please specify',
  OTHER_ARIA_LABEL: 'Please specify your reason for deactivating',
  SUBMIT_BUTTON: 'Submit',
  FINISH_BUTTON: 'Finish',
};

export const NON_RANDOMIZABLE_OPTIONS = [NOT_USED_WEBSITE_OPTIONS, OTHER_OPTION];

export const DEACTIVATION_REASONS_STEP = 'deactivation-reasons';
export const CONGRATS_STEP = 'congrats';
export const CLARIFY_QUESTION_STEP = 'clarify-question';
export const THANK_YOU_STEP = 'thank-you';
export const ALTERNATIVE_OPTIONS_STEP1 = 'alternative-options1';
export const ALTERNATIVE_OPTIONS_STEP2 = 'alternative-options2';
export const ALTERNATIVE_OPTIONS_STEP3 = 'alternative-options3';

export const DEACTIVATION_REASONS_STEP_DATA = {
  options: [
    {
      option: ALREADY_SOLD_REASON,
      nextStep: CONGRATS_STEP,
    },
    {
      option: 'No longer selling my car',
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: 'Something was wrong with how my listing looked',
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: 'I did not get any offers from buyers',
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: OTHER_OPTION,
      nextStep: CLARIFY_QUESTION_STEP,
    },
  ],
  subheader: 'Please tell us what prompted you to deactivate your listing?',
  subheaderClassNames: 'size-16 fw-bold pb-1',
};
export const ALTERNATIVE_OPTIONS_STEP_DATA = {
  options: [
    {
      option: 'Cars.com',
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: 'Autotrader',
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: 'Craigslist',
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: 'Edmunds',
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: 'Facebook Marketplace',
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: NOT_USED_WEBSITE_OPTIONS,
      nextStep: CLARIFY_QUESTION_STEP,
    },
    {
      option: OTHER_OPTION,
      nextStep: CLARIFY_QUESTION_STEP,
    },
  ],
  subheaderClassNames: 'size-16 fw-medium pb-1',
};
export const ALTERNATIVE_OPTIONS_STEP_DATA1 = {
  ...ALTERNATIVE_OPTIONS_STEP_DATA,
  subheader: 'How did you find the dealer you bought from?',
  subactionName: 'how_traded_in',
  subactionNameOther: 'traded_in_other',
};
export const ALTERNATIVE_OPTIONS_STEP_DATA2 = {
  ...ALTERNATIVE_OPTIONS_STEP_DATA,
  subheader: 'How did you find the dealer you sold your car to?',
  subactionName: 'how_sold_to_dealer',
  subactionNameOther: 'sold_to_dealer_other',
};
export const ALTERNATIVE_OPTIONS_STEP_DATA3 = {
  ...ALTERNATIVE_OPTIONS_STEP_DATA,
  subheader: 'How did you sell your car privately?',
  subactionName: 'how_sold_privately',
  subactionNameOther: 'sold_privately_other',
};
export const CONGRATS_STEP_DATA = {
  options: [
    {
      option: 'Traded-in to a dealer as part of a purchase',
      nextStep: ALTERNATIVE_OPTIONS_STEP1,
    },
    {
      option: 'Sold to a dealer without a purchase',
      nextStep: ALTERNATIVE_OPTIONS_STEP2,
    },
    {
      option: 'Sold to a private buyer',
      nextStep: ALTERNATIVE_OPTIONS_STEP3,
    },
  ],
  header: 'Congrats on the sale!',
  subheader: "We're curious - how did you end up selling your car?",
  subheaderClassNames: 'size-16 fw-medium pb-1',
  subactionName: 'select_how_sold',
};
export const CLARIFY_QUESTION_STEP_DATA = {
  subheader: 'What could have made the experience better for you?',
  subheaderClassNames: 'pb-1 fw-medium',
  showTextArea: true,
  cta: SURVEY_TEXTS.FINISH_BUTTON,
  nextStep: THANK_YOU_STEP,
};
export const THANK_YOU_STEP_DATA = {
  subheader: 'Thank you for your feedback!',
  subheaderClassNames: 'size-20 my-2_5 pb-1_5',
};
export const STEPS_DATA = {
  [DEACTIVATION_REASONS_STEP]: DEACTIVATION_REASONS_STEP_DATA,
  [CONGRATS_STEP]: CONGRATS_STEP_DATA,
  [ALTERNATIVE_OPTIONS_STEP1]: ALTERNATIVE_OPTIONS_STEP_DATA1,
  [ALTERNATIVE_OPTIONS_STEP2]: ALTERNATIVE_OPTIONS_STEP_DATA2,
  [ALTERNATIVE_OPTIONS_STEP3]: ALTERNATIVE_OPTIONS_STEP_DATA3,
  [CLARIFY_QUESTION_STEP]: CLARIFY_QUESTION_STEP_DATA,
  [THANK_YOU_STEP]: THANK_YOU_STEP_DATA,
};
